import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const TARGET = new Date("2026-09-17T18:00:00-07:00").getTime();

const getLeft = () => {
  const d = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(d / 86400000),
    hours: Math.floor((d / 3600000) % 24),
    mins: Math.floor((d / 60000) % 60),
    secs: Math.floor((d / 1000) % 60),
  };
};

const Digit = ({ value }) => (
  <span className="relative inline-block overflow-hidden" style={{ height: "1em", minWidth: "0.62em" }}>
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.span
        key={value}
        initial={{ y: "100%", opacity: 0 }}
        animate={{ y: "0%", opacity: 1 }}
        exit={{ y: "-100%", opacity: 0 }}
        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
        className="inline-block"
      >
        {value}
      </motion.span>
    </AnimatePresence>
  </span>
);

export const Countdown = () => {
  const [t, setT] = useState(getLeft);

  useEffect(() => {
    const id = setInterval(() => setT(getLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    ["DAYS", t.days],
    ["HRS", t.hours],
    ["MIN", t.mins],
    ["SEC", t.secs],
  ];

  return (
    <div className="flex items-center gap-2.5" data-testid="hero-countdown">
      {units.map(([label, value], i) => {
        const str = String(value).padStart(2, "0");
        return (
          <div key={label} className="flex items-center gap-2.5">
            <div className="text-center px-3.5 py-2.5 border border-black/10" style={{ background: "rgba(124,58,237,0.07)" }}>
              <p className="font-mono-c font-bold text-2xl leading-none tabular-nums" style={{ color: "#6D28D9" }} data-testid={`countdown-${label.toLowerCase()}`}>
                {str.split("").map((d, di) => <Digit key={di} value={d} />)}
              </p>
              <p className="font-mono-c text-[8px] tracking-[0.3em] text-black/35 mt-1.5">{label}</p>
            </div>
            {i < 3 && <span className="font-mono-c text-black/25 text-lg">:</span>}
          </div>
        );
      })}
    </div>
  );
};
